import linkHrefSelector from 'root/src/client/logic/app/selectors/linkHrefSelector';
import router from 'next/router';
export default (route) => {
    // @ts-ignore
    const href = linkHrefSelector({}, route);
    return router.push(href);
};
